export default {
    // invoiceLists: [],
    invoiceInfo: null,
    logisticDetail: null,
    invoiceApplyDetail: null
}


// WEBPACK FOOTER //
// ./src/store/invoice-manage/state.js